import { GridItem, HStack, useBreakpointValue } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import StyledButton from '../../../../components/StyledButton';
import { useFormItems } from '../../../../hooks/formItems';
import { MasterKey } from '../../../../models/gen/masterKey';
import { ZipCodeUtils } from '../../../../utils/ZipCode';
import { useMasterContext } from '../../../MasterProvider';
import InformationItems, { ItemCommonProps } from './Information';
import { UserInfoState } from './UserInfoAccordion';

/**
 * 基本情報
 */
type BasicState = Pick<
  UserInfoState,
  | 'account'
  | 'roleId'
  // | 'name'
  // | 'nameK'
  | 'officeId'
  | 'mailAddr'
  // | 'gender'
  | 'dateOfBirth'
  | 'tel'
  | 'adderssInfo'
  | 'station'
>;

/**
 * 基本情報
 * @param props - プロパティ
 * @returns
 */
const BasicInformation: React.FunctionComponent<ItemCommonProps> = (props) => {
  // const { state } = useGlobalStateMachine();
  const form = useFormContext<BasicState>();
  const { FormDatePicker, FormInput, FormSelect, FormText } =
    useFormItems(form);
  const master = useMasterContext();

  const emptyGridItemHidden = useBreakpointValue({ base: true, md: false });

  return (
    <InformationItems name="基本情報" panelIndex={0}>
      <GridItem hidden={props.isOutsourcer} margin={2}>
        <FormText label="アカウント名" name="account" />
      </GridItem>
      <GridItem hidden={props.isOutsourcer} margin={2}>
        <FormText
          label="区分"
          name="roleId"
          value={(field) =>
            master.getBy(MasterKey.Roles, field.value)?.name || '―'
          }
        />
      </GridItem>
      {/* <GridItem hidden margin={2}>
        <FormInput
          formControlProps={{
            isRequired:
              TypeUtils.isNilNumber(state.pageInfo.USER_INFO?.openedPanel) ||
              state.pageInfo.USER_INFO?.openedPanel === 0,
          }}
          label="氏名"
          mode={props.mode}
          name="name"
        />
      </GridItem> */}
      {/* <GridItem margin={2}>
        <FormInput label="氏名 (カナ)" mode={props.mode} name="nameK" />
      </GridItem> */}
      <GridItem hidden={props.isOutsourcer} margin={2}>
        <FormText
          label="所属"
          name="officeId"
          value={(field) =>
            props.master.getBy(MasterKey.Offices, field.value)?.name || '―'
          }
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput label="メールアドレス" mode={props.mode} name="mailAddr" />
      </GridItem>
      {/* <GridItem margin={2}>
        <FormSelect
          formControlProps={{
            isRequired: true,
          }}
          label="性別"
          mode={props.mode}
          name="gender"
          options={[
            { value: '1', valueToDisplay: '男性' },
            { value: '2', valueToDisplay: '女性' },
            { value: '9', valueToDisplay: 'その他' },
          ]}
        />
      </GridItem> */}
      <GridItem margin={2}>
        <FormDatePicker
          datePickerProps={{ showYearDropdown: true, dropdownMode: 'select' }}
          label="生年月日"
          mode={props.mode}
          name="dateOfBirth"
          onClickClear={(name) => form.setValue(name, '')}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput label="電話番号" mode={props.mode} name="tel" />
      </GridItem>
      <GridItem hidden={emptyGridItemHidden || !props.isOutsourcer} />
      <GridItem as={HStack} justifyContent="space-between" margin={2}>
        <FormInput
          formControlProps={{ width: 'calc(100% - 70px)' }}
          inputProps={{ maxLength: 7 }}
          label="郵便番号"
          mode={props.mode}
          name="adderssInfo.zipCode"
        />
        <StyledButton
          marginTop="auto !important"
          hidden={props.mode !== 'edit'}
          onClick={() =>
            ZipCodeUtils.zipCodeToAddress(
              form.getValues('adderssInfo.zipCode')
            ).then((address) => {
              const data =
                Array.isArray(address.data) && address.data.length > 0
                  ? address.data[0]
                  : undefined;
              form.setValue('adderssInfo.address1', data?.ja.prefecture);
              form.setValue('adderssInfo.address2', data?.ja.address1);
              form.setValue(
                'adderssInfo.address3',
                (data?.ja.address2 || '') + (data?.ja.address3 || '')
              );
            })
          }
        >
          検索
        </StyledButton>
      </GridItem>
      <GridItem hidden={emptyGridItemHidden} />
      <GridItem margin={2}>
        <FormSelect
          label="住所 (都道府県)"
          mode={props.mode}
          name="adderssInfo.address1"
          options={[
            { value: '北海道' },
            { value: '青森県' },
            { value: '岩手県' },
            { value: '宮城県' },
            { value: '秋田県' },
            { value: '山形県' },
            { value: '福島県' },
            { value: '茨城県' },
            { value: '栃木県' },
            { value: '群馬県' },
            { value: '埼玉県' },
            { value: '千葉県' },
            { value: '東京都' },
            { value: '神奈川県' },
            { value: '新潟県' },
            { value: '富山県' },
            { value: '石川県' },
            { value: '福井県' },
            { value: '山梨県' },
            { value: '長野県' },
            { value: '岐阜県' },
            { value: '静岡県' },
            { value: '愛知県' },
            { value: '三重県' },
            { value: '滋賀県' },
            { value: '京都府' },
            { value: '大阪府' },
            { value: '兵庫県' },
            { value: '奈良県' },
            { value: '和歌山県' },
            { value: '鳥取県' },
            { value: '島根県' },
            { value: '岡山県' },
            { value: '広島県' },
            { value: '山口県' },
            { value: '徳島県' },
            { value: '香川県' },
            { value: '愛媛県' },
            { value: '高知県' },
            { value: '福岡県' },
            { value: '佐賀県' },
            { value: '長崎県' },
            { value: '熊本県' },
            { value: '大分県' },
            { value: '宮崎県' },
            { value: '鹿児島県' },
            { value: '沖縄県' },
          ]}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput
          label="住所 (市区町村)"
          mode={props.mode}
          name="adderssInfo.address2"
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput label="住所" mode={props.mode} name="adderssInfo.address3" />
      </GridItem>
      <GridItem margin={2}>
        <FormInput
          label="住所 (ビル名等)"
          mode={props.mode}
          name="adderssInfo.address4"
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput label="最寄駅" mode={props.mode} name="station" />
      </GridItem>
    </InformationItems>
  );
};

export default BasicInformation;
